import { MailboxInfo } from 'owa-client-ids';
import { action } from 'satcheljs';
import ItemId from 'owa-service/lib/contract/ItemId';

export interface ItemContext {
    itemId: string;
    itemConversationId: ItemId;
    isRead: boolean;
    mailboxInfo: MailboxInfo;
}

/**
 * Action to propagate the delete items action to client stores
 * @param itemContexts - the contexts for items being deleted
 * @param parentFolderId - the parent FolderId
 */
export default action(
    'DELETE_ITEMS_STORE_UPDATE',
    (itemContexts: ItemContext[], parentFolderId: string) => {
        return {
            itemContexts,
            parentFolderId,
        };
    }
);
